<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication">For my mother, who helped me</p>
<p class="center">find that special island</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-dedication.vue?3aa981ca